/**
 * Created by Administrator on 2017/10/27.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
import { FormBuilder } from "@angular/forms";
declare var alertify: any;
@Component({
  templateUrl: './fanstvEdit.html'
})

export class FanstvEdit implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private fileupload: FileUpload,
    private location: Location
  ) { }

  private contentEn: string = '<p></p>';
  private contentTc: string = '<p></p>';
  private data: any = {
    "contentEn": "",
    "contentTc": "",
    "id": "",
    "imageEn": "",
    "imageTc": ""
  }

  private id: number = 0;
  private imagePath: string = '';
  private isCreate: boolean = false;
  private language = 'tc';
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
    if (this.id != 0) {
      this.getPath();
      this.getData();
    } else {
      this.isCreate = true;
    }
  }
  private showByLanguage(type: string) {
    this.language = type;
  }

  private getData(): void {
    this.HttpService.getData(API.fanstv + '/' + this.id).then(res => {
      this.data = res.data;
      this.contentEn = this.data.contentEn;
      this.contentTc = this.data.contentTc;
    })
  }

  // 获取路径
  private getPath(): void {
    this.HttpService.getData(API.resourcePath)
      .then(res => {
        this.imagePath = res.data;
        console.log(res.data)
      })
  }
  private onReady(str: string): void {
    if (str == 'en') {
      this.contentEn = this.data.contentEn;
    } else if (str == 'tc') {
      this.contentTc = this.data.contentTc;
    }
  }

  private submit(): void {
    this.HttpService.postData(API.fanstv, {
      'id': this.id,
      "contentEn": this.data.contentEn,
      "contentTc": this.data.contentTc,
      "imageEn": this.data.imageEn,
      "imageTc": this.data.imageTc
    }).then(res => {
      let data = res;
      if (data.status.code == 0 || data.status.code == '0') {
        this.location.back();
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }
  private onChange(str: string): void {
    if (str == 'en') {
      this.contentEn = this.data.contentEn;
    } else if (str == 'tc') {
      this.contentTc = this.data.contentTc;
    }
  }
  private showIconEn: boolean = false;
  private showIconTc: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case 'imageEn': self.showIconEn = true; break;
          case 'imageTc': self.showIconTc = true; break;
        }
        self.data[name] = temRes.data.fileName;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/film/fanstvEdit.component.ts